import React, { useState, useEffect } from 'react';
import axios from 'axios';

const OwnerInventory = () => {
    const [lowInventory, setLowInventory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [filterType, setFilterType] = useState('');

    const fetchLowInventory = async () => {
        try {
            setLoading(true);
            const response = await axios.get('https://rotica.in/get_low_inventory.php');

            if (response.data.success) {
                setLowInventory(response.data.low_inventory);
            } else {
                setError(response.data.message || "Failed to fetch inventory.");
            }
        } catch (err) {
            console.error(err);
            setError("Network Error: Could not fetch inventory.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLowInventory();
    }, []);

    const filteredInventory = filterType
        ? lowInventory.filter(item => item.entity_type === filterType)
        : lowInventory;

    const getStockStatus = (qty, threshold) => {
        const percentage = (qty / threshold) * 100;
        if (percentage < 20) return 'critical';
        if (percentage < 50) return 'low';
        return 'warning';
    };

    return (
        <div className="dashboard-container">
            <div className="main-content">
                <header className="page-header">
                    <h1>Low Stock Alerts</h1>
                    <p className="subtitle">Entities with inventory below threshold</p>
                </header>

                <div className="stats-cards">
                    <div className="stat-card" style={{ borderLeft: '4px solid #e74c3c' }}>
                        <h3>Total Low Stock Items</h3>
                        <p>{lowInventory.length}</p>
                    </div>
                    <div className="stat-card">
                        <h3>Manufacturers</h3>
                        <p>{lowInventory.filter(i => i.entity_type === 'manufacturer').length}</p>
                        <small style={{ color: '#888' }}>Threshold: &lt; 50</small>
                    </div>
                    <div className="stat-card">
                        <h3>Distributors</h3>
                        <p>{lowInventory.filter(i => i.entity_type === 'distributor').length}</p>
                        <small style={{ color: '#888' }}>Threshold: &lt; 10</small>
                    </div>
                </div>

                <div className="orders-section">
                    <div className="filters-bar">
                        <div className="filter-group">
                            <label>Entity Type</label>
                            <select
                                className="filter-select"
                                value={filterType}
                                onChange={(e) => setFilterType(e.target.value)}
                            >
                                <option value="">All</option>
                                <option value="distributor">Distributors</option>
                                <option value="manufacturer">Manufacturers</option>
                            </select>
                        </div>
                        <button className="clear-btn" onClick={() => setFilterType('')}>
                            Clear Filter
                        </button>
                    </div>

                    {loading && <p>Loading inventory...</p>}
                    {error && <p className="error-text">{error}</p>}

                    {!loading && !error && (
                        <div className="table-wrapper">
                            <table className="orders-table">
                                <thead>
                                    <tr>
                                        <th>Entity</th>
                                        <th>Type</th>
                                        <th>Product</th>
                                        <th>Current Stock</th>
                                        <th>Threshold</th>
                                        <th>Status</th>
                                        <th>Last Updated</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredInventory.length > 0 ? (
                                        filteredInventory.map((item, idx) => (
                                            <tr key={idx}>
                                                <td style={{ fontWeight: 600 }}>{item.entity_name}</td>
                                                <td>
                                                    <span className={`assigned-badge ${item.entity_type}`}>
                                                        {item.entity_type.charAt(0).toUpperCase() + item.entity_type.slice(1)}
                                                    </span>
                                                </td>
                                                <td>
                                                    {item.product_name}
                                                    {item.weight_spec && <small style={{ color: '#888' }}> ({item.weight_spec})</small>}
                                                </td>
                                                <td>
                                                    <span style={{
                                                        fontWeight: 'bold',
                                                        color: getStockStatus(item.stock_qty, item.threshold) === 'critical' ? '#e74c3c' : '#d35400'
                                                    }}>
                                                        {item.stock_qty}
                                                    </span>
                                                </td>
                                                <td style={{ color: '#888' }}>&lt; {item.threshold}</td>
                                                <td>
                                                    <span className={`stock-badge ${getStockStatus(item.stock_qty, item.threshold)}`}>
                                                        {getStockStatus(item.stock_qty, item.threshold) === 'critical' ? 'Critical' : 'Low'}
                                                    </span>
                                                </td>
                                                <td style={{ fontSize: '12px', color: '#888' }}>
                                                    {item.updated_at ? new Date(item.updated_at).toLocaleString() : '-'}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7" style={{ textAlign: "center", padding: "40px", color: '#27ae60' }}>
                                                ✓ No low stock items found. All inventory levels are healthy!
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OwnerInventory;
